import store from '../store';

export default class Auth {
  constructor(api) {
    this.api = api
  }

  login(username, password) {
    return new Promise((resolve, reject) => {
      this.api._call({
        '_class': 'Auth',
        '_method': 'login',
        'oid': store.getters.user.oid || store.getters.oid,
        'username': username,
        'password': password
      })
        .then(res => {
          // TODO: validation
          const user = {
            ticket: res.ticket._text,
            fullname: res.fullname._text,
            name: res.name._text,
            oid: parseInt(res.oid._text, 10),
            cont_lang_id: res.cont_lang_id._text,
            gui_lang_id: res.gui_lang_id._text,
            gui_lang_locale: res.gui_lang_locale._text,
            validation_cookie: {
              name: res.validation_cookie.name._text,
              value: res.validation_cookie.value._text,
            }
          }
          store.dispatch('login', user)
          resolve(user)
        }, response => {
          reject(response)
        })
    })
  }
}